<template>
  <div class="stock-search" :class="{ compact }">
    <el-popover v-model="searchOpen" trigger="manual" placement="bottom-end" :width="300" popper-class="stock-search-popover" :disabled="!search.trim()">
      <div class="stock-search-results" @mousedown.prevent>
        <p v-if="searchLoading">搜索中...</p>
        <p v-else-if="searchFailed">搜索失败 <button type="button" @click="onSearch">重试</button></p>
        <p v-else-if="!searchResults.length">暂无匹配股票</p>
        <button v-for="(item, index) in searchResults" :key="item.symbol || item.full_code || index" type="button" @click="selectSearchStock(item)"><span>{{ item.name || item.prod_name }}</span><small>{{ item.full_code || item.symbol }}</small></button>
      </div>
      <form slot="reference" class="stock-search-form" role="search" @submit.prevent="onSearch">
        <input v-model="search" type="search" aria-label="搜索股票名称或代码" :placeholder="compact ? '名称/代码' : '输入股票名称/代码'" autocomplete="off" @focus="searchOpen = !!search.trim()" @blur="searchOpen = false" @keydown.esc="searchOpen = false">
        <button type="submit" aria-label="搜索" title="搜索"><i class="el-icon-search" aria-hidden="true"></i></button>
      </form>
    </el-popover>
  </div>
</template>
<script>
import { marketEnabled } from '@/utils/systemConfig'
import { stockSelection } from '@/views/stock/stockSelection'
import { apiSearchStock } from '@/utils/requestapis'
export default {
  name: 'StockSearch',
  props: { compact: Boolean },
  data: () => ({ search: '', searchOpen: false, searchResults: [], searchLoading: false, searchFailed: false, searchTimer: null, searchRequest: 0 }),
  beforeDestroy() { clearTimeout(this.searchTimer); this.searchRequest++ },
  watch: {
    search() {
      clearTimeout(this.searchTimer); this.searchRequest++; this.searchResults = []; this.searchFailed = false; this.searchLoading = false
      this.searchOpen = !!this.search.trim()
      if (this.search.trim()) this.searchTimer = setTimeout(() => this.onSearch(), 250)
    },
    '$route.fullPath'() { clearTimeout(this.searchTimer); this.searchRequest++; this.searchOpen = false; this.searchLoading = false }
  },
  methods: {
    async onSearch() {
      clearTimeout(this.searchTimer)
      const code = this.search.trim(), request = ++this.searchRequest
      if (!code) { this.searchResults = []; this.searchOpen = false; return }
      this.searchOpen = true; this.searchLoading = true; this.searchFailed = false
      try {
        const result = await apiSearchStock({ code })
        if (request !== this.searchRequest) return
        if (!result || !Array.isArray(result.data)) throw new Error('Invalid stock results')
        this.searchResults = result.data.filter(item => marketEnabled(stockSelection(item).market))
      } catch (_) { if (request === this.searchRequest) { this.searchResults = []; this.searchFailed = true } }
      finally { if (request === this.searchRequest) this.searchLoading = false }
    },
    selectSearchStock(item) {
      if (!marketEnabled(stockSelection(item).market)) { this.$message.warning('当前市场暂未开放'); return }
      const symbol = /^us/i.test(item.full_code || '') ? item.full_code : item.symbol || item.full_code
      if (!symbol) { this.$message.warning('该股票缺少 symbol，无法打开'); return }
      clearTimeout(this.searchTimer); this.searchRequest++; this.searchOpen = false
      this.$router.push({ path: '/stocks', query: { symbol, name: item.name || item.prod_name || '' } }).catch(() => {})
    }
  }
}
</script>
<style scoped>
.stock-search { width: 300px; min-width: 0; }
.stock-search.compact { flex: 1; width: auto; min-width: 88px; max-width: 240px; }
.stock-search-form { display: flex; height: 32px; margin: 0; border: 1px solid var(--theme-border); border-radius: 5px; background: var(--theme-input); overflow: hidden; }
.compact .stock-search-form { height: 28px; }
.stock-search-form:focus-within { border-color: var(--theme-accent); }
.stock-search-form input { flex: 1; width: 0; min-width: 0; height: 100%; padding: 0 9px; border: 0; outline: none; background: transparent; color: var(--theme-text); font: inherit; font-size: 13px; }
.stock-search-form input::placeholder { color: var(--theme-muted); }
.stock-search-form button { flex: 0 0 32px; padding: 0; border: 0; border-left: 1px solid var(--theme-border); background: var(--theme-header); color: var(--theme-accent); cursor: pointer; font-size: 16px; }
.stock-search-form button:hover { background: var(--theme-hover); }
.stock-search-form button:focus-visible { outline: 2px solid var(--theme-accent); outline-offset: -2px; }
</style>
<style>
.stock-search-popover.el-popover { padding: 0; background: var(--theme-panel); color: var(--theme-text); border-color: var(--theme-border); }
.stock-search-popover .popper__arrow::after { border-bottom-color: var(--theme-panel) !important; }
.stock-search-results { max-height: min(420px, calc(100vh - 160px)); overflow-y: auto; line-height: 1.5; }
.stock-search-results button { display: flex; justify-content: space-between; gap: 12px; width: 100%; border: 0; border-bottom: 1px solid var(--theme-border); background: transparent; color: var(--theme-text); text-align: left; padding: 10px 12px; cursor: pointer; font: inherit; }
.stock-search-results button:hover, .stock-search-results button:focus-visible { background: var(--theme-hover); color: var(--theme-accent); }
.stock-search-results small { flex-shrink: 0; color: var(--theme-muted); }
.stock-search-results p { padding: 12px; margin: 0; color: var(--theme-muted); }
</style>
